const HeadersRequests = [
  { text: 'ID', value: 'request.display_id', sortable: false, show: true },
  { text: 'Estado', value: 'request.status_request.id', sortable: false, show: true },
  { text: 'Rubro', value: 'request.service.rubro.name', sortable: false, show: true },
  { text: 'Servicio', value: 'request.service.name', sortable: false, show: true },
  { text: 'Cliente', value: 'request.client.full_name', sortable: false, show: true },
  { text: 'Dirección', value: 'request.full_address', sortable: false, show: true },
  { text: 'Ciudad', value: 'request.neighborhood.city.name', sortable: false, show: true }
]

export default HeadersRequests
